import api from './api';

export async function postAppEvent({ deviceId, event, appVersion, platform }) {
  try {
    await api.post('/app-events', { deviceId, event, appVersion, platform });
  } catch (e) {
    console.warn('postAppEvent failed', e?.message);
  }
}

export async function getAppEventExists(deviceId) {
  try {
    const { data } = await api.get(`/app-events/${deviceId}`);
    // data: { ok, exists, lastEvent, lastSeenAt, platform }
    return !!data?.exists;
  } catch (e) {
    console.warn('getAppEventExists failed', e?.message);
    return false; // fail-open (treat as not existing)
  }
}
